export const NEW_PROPERTY_STEPS: string[] = [
  "Choose Plan",
  "Add New Property",
  "Property Info",
  "Signer Info",
  "Payment",
  "Review",
  "Success",
];

